import { AUTH_LOGIN, AUTH_ERROR, AUTH_CHECK } from 'react-admin';

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const login_type = 'json_reply';
    const username = [params.username];
    const password = [params.password];
    const request = new Request('/api/authenticate', {
      method: 'POST',
      body: JSON.stringify({ username, password, login_type }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
      credentials: 'include'
    });
    return fetch(request).then(response => {
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      return response.json();
    });
    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    const status = params.status;
    if (status === 401 || status === 403 || status === 422) {
      return Promise.reject();
    }
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    console.log("\n************** auth check being called")
    const login_type = 'json_reply';
    const request = new Request('/api/check_login', {
      method: 'POST',
      body: JSON.stringify({ login_type }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
      credentials: 'include'
    });
    return fetch(request).then(response => {
      console.dir(response)
      if (response.status < 200 || response.status >= 300) {
        console.log("Session not active")
        return Promise.reject();
      }
      console.log("login session ok")
      return Promise.resolve();
    });
  }
};



// WEBPACK FOOTER //
// ./src/authProvider.js